/**
 * Single source of truth for link type color mappings.
 *
 * These colors are used across the markup/link system:
 *  - ImportLinksInlinePanel (import preview boxes/icons)
 *  - markupsPopup (saved link boxes/icons + preview cursor)
 *  - forgeService.create3DIconToViewer (3D icon rendering)
 *  - MarkupLinksPanel (links panel tree nodes + flash animation)
 *  - DocumentLinksPanel (document links panel tree nodes)
 *
 * NOTE: These are purely frontend presentation colors.
 * The API returns type discriminator strings, never colors.
 * The separate 3D tag colors in forgeModels.js (TAG_COLOR/TAG_COLOR_HEX)
 * are a different palette for a different UI context and are already centralized.
 */

/** Hex color map — used for CSS, canvas rendering, and icon styling */
export const LINK_TYPE_COLORS = {
  'P&ID': '#FFC107',
  'Equipment': '#4CAF50',
  'Pipeline': '#00BCD4',
  'Structural': '#F44336',
  'Inspection': '#FF9800',
  'Anomaly': '#FF5722',
  'Annotation': '#2196F3',
  'Container': '#9C27B0',
  'Permit': '#3F51B5',
  'Scaffold': '#795548',
  'CML': '#8BC34A',
  'TML': '#CDDC39',
  'default': '#9E9E9E',
};

/** Vuetify color class map — used for Vuetify component `color` props */
export const LINK_TYPE_VUETIFY_COLORS = {
  'P&ID': 'amber',
  'Equipment': 'green',
  'Pipeline': 'cyan',
  'Structural': 'red',
  'Inspection': 'orange',
  'Anomaly': 'deep-orange',
  'Annotation': 'blue',
  'Container': 'purple',
  'Permit': 'indigo',
  'Scaffold': 'brown',
  'Tags': 'teal',
  'CML': 'light-green',
  'TML': 'lime',
  'Monitoring': 'blue-grey',
  'Other': 'grey',
  'default': 'grey',
};
